import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import { getActiveUserInfo } from '../../state/selectedUser/index';
import {USER_ROLES} from "../../state/selectedUser/constants";

const isEmpty = (obj) => { return obj && Object.keys(obj).length === 0; };

const ProtectedRoute = ({ 
  children, 
  requireSuperAdmin = false
}) => {
  const activeUser = useSelector(state => getActiveUserInfo(state));

  if (isEmpty(activeUser)) {
    return <Redirect to="/" replace />;
  }

  const userRole =  activeUser?.roles[0];

  if (requireSuperAdmin) {
    const isSuperAdmin = USER_ROLES.SUPERADMIN === userRole;
    
    if (!isSuperAdmin) {
      return <Redirect to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;